import script from "./LabelUPS.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelUPS.vue?vue&type=script&setup=true&lang=ts"

import "./LabelUPS.vue?vue&type=style&index=0&id=6f9649d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9649d0"]])

export default __exports__